import React from 'react';
import { Card, Stack, Typography } from 'components/base';
import { Button } from 'components/atoms';

type HeaderProps = {
  form_title: string;
  form_description: string;
  handleSubmit: () => void;
  isLoading: boolean;
};

export const Header: React.FC<HeaderProps> = ({
  form_title,
  form_description,
  handleSubmit,
  isLoading,
}) => {
  return (
    <Card sx={{ p: 2, width: '80%' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack>
          <Typography variant="h6">{form_title}</Typography>
          <Typography variant="body2">{form_description}</Typography>
        </Stack>
        <Button onClick={handleSubmit} isLoading={isLoading}>
          Submit
        </Button>
      </Stack>
    </Card>
  );
};
